import React from "react";
import Select from "react-select";

const DropdownFilter = ({ label, value, options, onChange }) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: "120px",
      minHeight: "0",
      height: "auto",
      borderRadius: "4px",
      border: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
      "&:hover": {
        border: "none",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0 0 0 4px",
      color: "#64748b",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#eff6ff" : "white",
      color: state.isSelected ? "#1e293b" : "#142A31",
      fontSize: "13px",
      fontWeight: state.isSelected ? "600" : "500",
      padding: "8px 12px",
      "&:hover": {
        backgroundColor: "#f8fafc",
        color: "#3b82f6",
      },
    }),
    menu: (provided) => ({
      ...provided,
      border: "1.5px solid #e2e8f0",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      marginTop: "4px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#142A31",
      fontSize: "13px",
      fontWeight: "500",
    }),
  };

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <div className="filter-dropdown">
      <span>{label}:</span>
      <Select
        value={selectedOption}
        onChange={(selected) => onChange(selected.value)}
        options={options}
        styles={customStyles}
        isSearchable={false}
      />
    </div>
  );
};

export default DropdownFilter;
